import { forwardRef, memo } from "react";
import { useIntl } from "react-intl";
import { Modal, Header, Image } from "semantic-ui-react";

// Styles
import "./MeHeyLanding.scss";

type MeHeyLandingDownloadModProps = {
  open: boolean;
  onClose: () => void;
};

const IMAGES = {
  qrCode: "/static/images/mehey_landing/qrcode_downloadapp.png",
  androidBadge: "static/images/mehey_landing/badge-get-app-android.svg",
  iosBadge: "static/images/mehey_landing/badge-get-app-ios.svg"
};

const GET_APP_LINK = {
  android: "https://play.google.com/store/apps/details?id=com.morishealth.vc1",
  ios: "https://apps.apple.com/th/app/mehey/id6751217948",
};

const MeHeyLandingDownloadMod = memo(
  forwardRef<any, MeHeyLandingDownloadModProps>((props, ref) => {
    const intl = useIntl();

    const handleDownload = (url: string) => {
      window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
      <Modal
        className={props.open ? "fade-in" : "fade-out"}
        ref={ref}
        open={props.open}
        onClose={props.onClose}
        style={{ width: "max-content" }}
      >
        <div className="download-mod">
          <div style={{ textAlign: "center" }}>
            <Header
              style={{
                fontSize: "2rem",
                marginBottom: "1rem",
                display: "inline-block",
                padding: "4px 1rem 0 1rem",
              }}
              as="h2"
            >
              {intl.formatMessage({ id: "ดาวน์โหลดแอป IsHealth" })}
            </Header>
          </div>

          <div style={{ textAlign: "center" }}>
            <label>{intl.formatMessage({ id: "สแกน QR Code เพื่อดาวน์โหลด" })}</label>
            <div style={{ display: "flex", justifyContent: "center", padding: "1rem 0" }}>
              <div className="qr-code-gradient">
                <Image src={IMAGES.qrCode} size="medium" />
              </div>
            </div>
            <div className="get-mobile-app">
              <label>{intl.formatMessage({ id: "หรือคลิกเพื่อดาวน์โหลด" })}</label>
              <div style={{ display: "flex", justifyContent: "center", gap: "1rem", paddingTop: "1rem" }}>
                <Image
                  src={IMAGES.androidBadge}
                  size="small"
                  style={{ height: "48px" }}
                  onClick={() => handleDownload(GET_APP_LINK.android)}
                />
                <Image
                  src={IMAGES.iosBadge}
                  size="small"
                  style={{ height: "48px" }}
                  onClick={() => handleDownload(GET_APP_LINK.ios)}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  })
);

export default MeHeyLandingDownloadMod;
